// Styles used by native base
export const THEME_GREEN = '#376B35';
export const THEME_RED = '#C53933';
export const THEME_YELLOW = '#faa000';
export const THEME_GRAY = '#f3f4f6';
export const THEME_BLUE = '#21a2ff';

export const REQUIRED_ACTION = "bg-orange-100 text-orange-500";
export const ERROR = "bg-red-100 text-red-500";
export const SUCCESS = "bg-green-100 text-green-500";
export const INFO = "bg-sky-100 text-sky-500";

export const FIELD_BG_WHITE = {
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'white', // Set the background color to white
    }
};

export const SELECT_BG_WHITE = {
    '& .MuiInputBase-root': {
        backgroundColor: 'white', // Set the background color to white
    },
};

export const FIELD_STYLE = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'white',
            borderWidth: 2,
        },
        '&:hover fieldset': {
            borderColor: 'white',
        },
    },
    '& .MuiInputLabel-root': {
        color: 'white',
        backgroundColor: 'white'
    },
    'input': {
        '&::placeholder': {
            color: 'white'
        }
    }
};

export const POLICY_HEADING = "text-lg font-bold mt-6 mb-2";
export const POLICY_SUBHEADING = "text-themeRed mt-4 mb-2";
export const POLICY_CONTENT = "font-light";
export const POLICY_LIST = "font-light ml-4";
